var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCard3(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "45px",
    height: "51px",
    viewBox: "0 0 45 51",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Rectangle") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Project-Editor-4",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    stroke: "#4A4A4A",
    strokeWidth: 3,
    fill: "#FFFFFF",
    x: 2,
    y: 2,
    width: 40.6587302,
    height: 47
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#4A4A4A",
    x: 13,
    y: 31,
    width: 19,
    height: 4
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#4A4A4A",
    cx: 22,
    cy: 17,
    r: 10
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-19",
    transform: "translate(11.000000, 39.000000)",
    fill: "#4A4A4A",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3,0 C1.34325,0 0,1.34325 0,3 C0,4.65675 1.34325,6 3,6 C4.65675,6 6,4.65675 6,3 C6,1.34325 4.65675,0 3,0 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11,0 C9.34325,0 8,1.34325 8,3 C8,4.65675 9.34325,6 11,6 C12.65675,6 14,4.65675 14,3 C14,1.34325 12.65675,0 11,0 Z",
    id: "Path-Copy-7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19,0 C17.34325,0 16,1.34325 16,3 C16,4.65675 17.34325,6 19,6 C20.65675,6 22,4.65675 22,3 C22,1.34325 20.65675,0 19,0 Z",
    id: "Path-Copy-9"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-18",
    transform: "translate(15.000000, 11.000000)",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,1 C0,0.448 0.448,0 1,0 C1.552,0 2,0.448 2,1 C2,1.55266667 1.552,2 1,2 C0.448,2 0,1.55266667 0,1 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    points: "9.35714286 2 7.01807143 5.5 4.71428571 3.785 1 9 14 9"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCard3);
export default __webpack_public_path__ + "static/media/Card 3.b3eda4b2.svg";
export { ForwardRef as ReactComponent };